// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import './common/theme.scss'


import Vant from 'vant'
import 'vant/lib/index.css'
// 引入echarts
import * as echarts from 'echarts';

// 引入store
import store from "./store"
import './common/reset.css'
import './common/iconfont.css'

import Axios from 'axios'
//引入全局变量
import commonPRAS from "./common/constant"
import moment from 'moment'
import {refreshToken} from "./common/base";
// }


// 注册
Vue.use(Vant)

// 注册
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

Axios.defaults.withCredentials = true // 跨域保存session
//Axios.defaults.baseURL = "http://localhost:8080" // 默认基础路径配置，打包时删掉
Vue.prototype.$axios = Axios
Vue.prototype.commonPRAS = commonPRAS;
/* 定义全局变量
 * 常量定义全部大写字母组成
*/

/* eslint-disable no-new */
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,   // 这里是新添加的
  Axios,
  data: function () {
    return {}
  },
  components: {App},
  template: '<App/>'
})

Vue.filter('dateFormat', (date, format = "YYYY-MM-DD") => {
  if (!date || date == null) {
    return "N/A";
  }
  return moment(date).format(format);
})

Vue.filter('keep2Place', (dividend, divisor, place = 2) => {
  if (!divisor || divisor == 0) {
    return "N/A";
  }

  return (dividend / divisor * 100).toFixed(place) + "%";
})



// WEBPACK FOOTER //
// ./src/main.js